import React, { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { DashboardCard } from '@monorepo/nova-ui';

export const ProfitTargetCardSkeleton: FC = () => {
  return (
    <DashboardCard>
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%',
          width: '100%',
        }}
      >
        {/* Title */}
        <Skeleton variant="text" width={80} height={20} sx={{ mb: 2 }} />

        {/* Gauge area */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: 1,
            justifyContent: 'center',
          }}
        >
          {/* Semi-circle gauge skeleton */}
          <Skeleton
            variant="rectangular"
            width={120}
            height={60}
            sx={{
              borderRadius: '60px 60px 0 0',
              mb: 2,
            }}
          />

          {/* Gauge labels */}
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ width: 120 }}
          >
            <Skeleton variant="text" width={20} height={14} />
            <Skeleton variant="text" width={25} height={14} />
            <Skeleton variant="text" width={20} height={14} />
          </Stack>
        </Box>
      </Stack>
    </DashboardCard>
  );
};
